<template>
  <v-autocomplete
    outlined
    hide-details
    clearable
    return-object
    no-filter
    hide-selected
    hide-no-data
    single-line
    item-text="descricao"
    :label="label"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @focus="onFocus"
    v-bind="$attrs">
    <template v-slot:item="item">
      <v-list-item-content>
        <v-list-item-title>
          <v-chip label small v-if="item.item.codigoInterno">
            {{ item.item.codigoInterno }}
          </v-chip>
          {{ item.item.descricao }}
        </v-list-item-title>
      </v-list-item-content>
    </template>
    <template v-slot:selection="item">
      <div class="truncate-text">
        <v-chip label small v-if="item.item.codigoInterno">
          {{ item.item.codigoInterno }}
        </v-chip>
        {{ item.item.descricao }}
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import CentroCustoService from '@/api/centro-custo-service';

const DEFAULT_LIMIT = 100;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: Object,
    label: {
      type: String,
      default: 'Centro de custo',
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  watch: {
    search(val) {
      this.debounceSearch(val);
    },
  },
  methods: {
    searchItems(val) {
      const isSelected = this.localValue && this.localValue.descricao === val;

      const searchValue = isSelected || !val ? '' : val;

      this.loading = true;
      CentroCustoService.getCentroCustos({
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query: `descricao like "%${searchValue.toLowerCase()}%" or codigoInterno like "%${searchValue.toLowerCase()}%"`,
      })
        .then((response) => {
          if (this.value) {
            this.items = [this.value, ...response.data.content];
            return;
          }
          this.items = response.data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onFocus() {
      this.debounceSearch(null);
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchItems, 1000);
    this.debounceSearch();
  },
};
</script>
